import React from "react"
import {MainCP} from "../../Components/rol-medios-democracias/MainCP"

const ViewRolMediosDemocracias: React.FC = () => <MainCP/>

export default ViewRolMediosDemocracias;